import React, { useEffect, useState } from "react";

// JS Files
import MuiButton from "../shares/MuiButton";

// Others File
import question from "../../imgs/question.svg";

const Survey = () => {
  return (
    <>
      <div className="mt-10 md:mt-20 mx-4 md:mx-32 p-4 md:p-8 rounded-lg bg-myorange-600">
        <p className="text-center text-lg font-bold text-mygray-700">نظرسنجی</p>
        <div className="bg-white md:mx-32 px-4 py-8 mt-8 rounded-lg">
          <div className="flex flex-col md:flex-row items-center justify-center">
            <img src={question} className="w-12" />
            <span className="mt-4 md:mt-0 md:mr-4 text-mygray-800 text-center">
              شرکت در این نظرسنجی و ثبت عملکرد بیمه‌گر طرف قرارداد (بیمه دانا)
            </span>
          </div>
          <p className="text-sm leading-8 mt-4 mx-4 md:mx-12 text-mygray-500">
            در راستای شناسایی نقاط ضعف و مشکلات، چالش قرارداد بیمه‌ فرهنگیان و
            دانش آموزان ثبت نظرسنجی برای بیمه‌شدگان ایجاد گردیده است، ما را با
            شرکت در این نظرسنجی در ارائه خدمات بهتر کمک کنید.
          </p>
          <div className="flex justify-center mt-12">
            <a href="https://survey.porsline.ir/s/HnBvjG5g" target="_blank">
              <MuiButton
                withoutOnClick
                type="submit"
                variant="contained"
                color="primary"
                text="شرکت در نظرسنجی"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default Survey;
